import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { sendEmailVerification } from 'firebase/auth';
import { CampaignLoyaltyProgramme, IndefiniteLoyaltyProgramme, Outlet } from 'src/app/models/interfaces';
import { OutletPage } from 'src/app/pages/outlet/outlet.page';
import { AlertService } from 'src/app/services/alert.service';
import { AssetlinksService } from 'src/app/services/assetlinks.service';
import { AuthService } from 'src/app/services/auth.service';
import { CloudfunctriggersService } from 'src/app/services/cloudfunctriggers.service';
import { DateTimeService } from 'src/app/services/date-time.service';
import { HapticsService } from 'src/app/services/haptics.service';
import { LoyaltyCardService } from 'src/app/services/loyalty-card.service';
import { PushNotificationsService } from 'src/app/services/pushnotifications.service';
import { ToastServiceService } from 'src/app/services/toast-service.service';
import { TranslationService } from 'src/app/services/translation.service';
import { LoyaltyCardPreviewComponent } from 'src/app/shared/components/loyalty-card-preview/loyalty-card-preview.component';

@Component({
  selector: 'app-outlet-lane-card',
  templateUrl: './outlet-lane-card.component.html',
  styleUrls: ['./outlet-lane-card.component.scss'],
})
export class OutletLaneCardComponent implements OnInit {
  @Input() outlet: Outlet
  @Input() cardHeight = '50vh'
  @Output() onDealSelectEmit: EventEmitter<CampaignLoyaltyProgramme | IndefiniteLoyaltyProgramme> = new EventEmitter();
  @Output() onWantsToFlip: EventEmitter<any> = new EventEmitter();
  showDescription:boolean = false
  constructor(
    private modalCtrl: ModalController,
    private hapticsService: HapticsService,
    private cloudTriggers: CloudfunctriggersService,
    private loyaltyCardService: LoyaltyCardService,
    private authService: AuthService,
    private toasts: ToastServiceService,
    public assetLinksService: AssetlinksService,
    private dateTimeService: DateTimeService,
    private alertService: AlertService,
    private pushNotificationsService: PushNotificationsService,
    private ts: TranslationService,
  ) {

  }

  ngOnInit() {

  }

  toggleShowDescription(){
    this.showDescription = !this.showDescription
  }

  explainPoints(){
    this.toasts.showToast(
      "Outlets displaying this icon provide you with YumPoints along with the stamps you earn. YumPoints can be redeemed for a variety of rewards available in the YumPoints Exchange.",
      'YumPoints'
    )
  }

  flip() {
    this.onWantsToFlip.emit()
  }

  async cardClick() {
    try {
      const modal = await this.modalCtrl.create({
        component: OutletPage,
        mode: 'ios',
        initialBreakpoint: 1,
        breakpoints: [0, 1],
        handle:false,
        componentProps: {
          outlet:this.outlet,
          today:this.dateTimeService.giveLocalNowDay()
        }
      });
      await modal.present();
    } catch (error) {
      console.error(error)
    }
  }






 
}
